import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MenuEvent } from 'src/app/core/services/menuevent.service';
import { SharedService } from 'src/app/core/services/shared.service';
import { ModalCustomComponent } from 'src/app/shared/ui/modal-custom/modal-custom.component';

declare var $: any;
import Swal from 'sweetalert2';

@Component({
  selector: 'app-servicio-estudiante',
  templateUrl: './servicio-estudiante.component.html',
  styleUrls: ['./servicio-estudiante.component.scss']
})
export class ServicioEstudianteComponent implements OnInit {
  gfg: boolean;

  strDatosPersonales: string = "api/servicios/DatosPersonales";
  strSedes = "api/servicios_profesor/BuscarSedes";
  strPeriodosMatricula = "api/matricula/BuscarPeriodosMatricula";
  strCarreras = "api/matricula/BuscarCarrerasEstudiante";
  strSede = "";

  sedes = [];
  periodos = [];
  carreras = [];

  sedeSeleccionada = null;
  periodoSeleccionado = null;
  M04IUP = null;
  modalRef = null;

  @Input() pantalla;

  ahora: Date;
  cintillo = "";

  intervalo: ReturnType<typeof setInterval>;

  nuevoTab = { SYS02CON: "", titulo: "", Tipo: "", PAD18CON: "1423457", pantalla: 0 };
  datosPersonales = { M12NOM: "", M12AP1: "", M12AP2: "", M12DIR: "", M12TEL: "", M12CEL: "", M12CAR: "", M12EMA: "", MENSAJE: "", HORA: "" };

  @ViewChild('modalEstudianteSede') contenido: TemplateRef<any>;

  constructor(private menuEvent: MenuEvent, private dataService: SharedService, private modalService: NgbModal) { }

  ngOnInit(): void {
    this.dataService.ConsultarWS(this.strDatosPersonales, void 0).subscribe((datos: any) => {
      if (datos.DATA.length > 0) {
        this.datosPersonales = datos.DATA[0];
        this.cintillo = datos.DATA[0].HOME_AUTOMATRICULA_PAD31DES;
        let fecha = datos.DATA[0].FECHA_SERVIDOR.substring(0, 10);
        let strAhora = fecha.substring(6, 11) + "-" + fecha.substring(3, 5) + "-" + fecha.substring(0, 2) + datos.DATA[0].FECHA_SERVIDOR.substring(10);;
        this.ahora = new Date(Date.parse(strAhora));

        this.intervalo = setInterval(() => {
          let nueva = new Date(this.ahora.toISOString());
          nueva.setSeconds(this.ahora.getSeconds() + 1);
          this.ahora = nueva;
        }, 1000000);

        this.dataService.ConsultarWS(this.strSedes, void 0).subscribe((datos: any) => {
          this.sedes = datos.DATA;
          this.dataService.ConsultarWS(this.strPeriodosMatricula, void 0).subscribe((datos: any) => {
            this.periodos = datos.DATA;
            this.consultarConfiguracion();
            if (this.sedeSeleccionada == null) {
              this.abrirModal();
            } else {
              this.cambiarCarreras(this.sedeSeleccionada.M05COD);
            }
          });
        });
      } else {
        Swal.fire({
          html: '<div class="row align-items-center" style="width:100%; overflow:auto;"> ' +
            '<div class="col-5">' +
            ' <img src="assets/images/imageerror.png"> </img>' +
            '</div>' +
            ' <div class="col-7">' +
            '<h3>Error</h3><br>' +
            ' <p>Usuario sin datos</p>' +
            ' </div> ',
        });
      }
    }, (err: any) => {
      Swal.fire({
        html: '<div class="row align-items-center" style="width:100%; overflow:auto;"> ' +
          '<div class="col-5">' +
          ' <img src="assets/images/imageerror.png"> </img>' +
          '</div>' +
          ' <div class="col-7">' +
          '<h3>Error</h3><br>' +
          ' <p>' + err + '</p>' +
          ' </div> ',
      });
    });
  }

  ngOnDestroy() {
    clearInterval(this.intervalo);
  }

  abrirPerfil() {
    this.nuevoTab.SYS02CON = "3";
    this.nuevoTab.titulo = "Perfil";
    this.nuevoTab.Tipo = "PROFILE_COMPONENT";
    this.menuEvent.broadcast('ABRIR_NUEVO_TAB', this.nuevoTab);
  }

  abrirModal() {
    this.modalRef = this.modalService.open(ModalCustomComponent, { size: 'xl' });
    this.modalRef.componentInstance.sedes = this.sedes;
    this.modalRef.componentInstance.periodos = this.periodos;
    this.modalRef.componentInstance.carreras = this.carreras;
    this.modalRef.componentInstance.sedeSeleccionada = this.sedeSeleccionada;
    this.modalRef.componentInstance.periodoSeleccionado = this.periodoSeleccionado;
    this.modalRef.componentInstance.M04IUP = this.M04IUP;
    this.modalRef.componentInstance.origen = 1;
    this.modalRef.componentInstance.retornoSeleccionado.subscribe(($e) => {
      this.consultarConfiguracion();
    });

    this.modalRef.componentInstance.cambioCarreras.subscribe(($e) => {
      this.cambiarCarreras($e);
    });
  }

  cambiarCarreras(sede) {
    let parametros = { M05COD: sede };
    this.dataService.ConsultarWS(this.strCarreras, JSON.stringify(parametros)).subscribe((datos: any) => {
      this.carreras = datos.DATA;
      if (this.modalRef != null) {
        this.modalRef.componentInstance.carreras = this.carreras;
        this.modalRef.componentInstance.M04IUP = null;
      }
    });
  }

  seccion(numero) {
    this.pantalla = numero;
  }

  cambio() {
    this.gfg = !this.gfg;
  }

  cerrarBarra(valor: boolean) {
    this.gfg = valor;
  }

  mostrarSede(sede) {
    this.strSede = sede.M05DES;
  }

  consultarConfiguracion() {
    this.sedeSeleccionada = JSON.parse(localStorage.getItem("sede"));
    this.periodoSeleccionado = JSON.parse(localStorage.getItem("periodo"));
    this.M04IUP = localStorage.getItem("M04IUP");

  }
}
